import { useId } from "react";

const CustomBtn = ({ text, handleClick, isSelected }) => {
  const id = useId();
  return (
    <button
      id={id}
      key={id}
      className={`w-full text-white mb-12 mt-4 rounded-full py-3 text-center font-semibold text-sm transition
        ${isSelected ? 'bg-pink-300 cursor-not-allowed' : 'bg-pinkCustom hover:bg-pink-600'}`}
      onClick={handleClick}
      disabled={isSelected}
    >
      {text}
    </button>
  );
};

export default CustomBtn;